var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-success grid grid__base" }, [
    _c("div", { staticClass: "form-success--container grid--container" }, [
      _c("div", { staticClass: "form-success--row grid--row" }, [
        _c(
          "div",
          { staticClass: "form-success--col grid--col" },
          [
            _c("h1", { staticClass: "form-success--title u-reset" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.title) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "form-success--description" }, [
              _vm._v(_vm._s(_vm.lead))
            ]),
            _vm._v(" "),
            _c("link-list", { attrs: { links: [_vm.link] } })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e5973d0", { render: render, staticRenderFns: staticRenderFns })
  }
}